import React from "react";
import { TranslationContext } from "_metronic/i18n/language";
import { Dropdown } from "react-bootstrap";
import { RTLContext } from "themes/RTLProvider/RTLProvider";

const DashboardDropdownToggle = React.forwardRef((props, ref) => {
  return (
    <button
      ref={ref}
      id="kt_dashboard_dashboard"
      type="button"
      onClick={e => {
        e.preventDefault();
        props.onClick(e);
      }}
      className="btn btn-clean btn-sm btn-icon btn-icon-lg"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i className="flaticon-more-1"></i>
    </button>
  );
});

export default class DashboardDropdown extends React.Component {
  static contextType = TranslationContext;
  disableDropdown() {
    document.querySelectorAll("#kt_dashboard_dashboard")[0].click();
  }

  render() {
    const translate = this.context;
    const isRtl = RTLContext._currentValue

    return (
      <Dropdown className="kt-portlet__head-toolbar" drop="down" alignRight>
        <Dropdown.Toggle as={DashboardDropdownToggle} id="dropdown-toggle-top">
          <i className="flaticon-more-1" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right">
          <ul className="kt-nav">
            <li className="kt-nav__section kt-nav__section--first"
            style={{textAlign: isRtl ? 'right' : 'left'}}>
              <span className="kt-nav__section-text">
                {translate('screens.dashboard.action')}
              </span>
            </li>

            <li className="kt-nav__item">
              <a className="kt-nav__link">
                <i className="kt-nav__link-icon flaticon2-refresh"></i>
                <span
                  className="kt-nav__link-text"
                  onClick={() => {
                    this.props.onClickRefresh();
                    this.disableDropdown();
                  }}
                >
                  {translate('datatable.refresh')}
                </span>
              </a>
            </li>

            <li className="kt-nav__section kt-nav__section--first">
              <span className="kt-nav__section-text">
                {translate('datatable.export')}
              </span>
            </li>
            <li className="kt-nav__item">
              <a className="kt-nav__link">
                <i className="kt-nav__link-icon flaticon2-download"></i>
                <span
                  className="kt-nav__link-text"
                  onClick={() => {
                    this.props.onClickExport();
                    this.disableDropdown();
                  }}
                >
                  {translate('screens.dashboard.download')}
                </span>
              </a>
            </li>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
